import { ProductSizeLabelType } from "./ProductSizeLabelType.js";

export const sizeLabelsWithSize = [ProductSizeLabelType.Serving];
